export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8104.18b2db28.jpg";